package fr.frux.feature.favorites

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique du [FavoritesViewModel], honoré par le composition root (#43). */
fun interface FavoritesViewModelFactory {
    fun create(): FavoritesViewModel
}

/** Fabrique installée par le composition root ; sans défaut, pour que l'oubli de câblage crie. */
val LocalFavoritesViewModelFactory = staticCompositionLocalOf<FavoritesViewModelFactory> {
    error("FavoritesViewModelFactory absente : le composition root doit l'installer (cf. FruxCompositionRoot, #43)")
}

@Composable
fun rememberFavoritesViewModel(): FavoritesViewModel {
    val factory = LocalFavoritesViewModelFactory.current
    return viewModel { factory.create() }
}
